import { type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    style={{ overflow: 'visible', ...props.style }}
    {...props}
  >
    <g clipPath="url(#clip0_license_verification)">
      <path
        d="M6.42019 1.00912C7.92763 0.66853 9.50562 0.82446 10.9173 1.45345C11.1692 1.56588 11.2823 1.86155 11.1702 2.11361C11.0579 2.36573 10.7622 2.47966 10.51 2.36751C9.29537 1.82629 7.93799 1.69165 6.6409 1.9847C5.3438 2.27776 4.17579 2.98262 3.3118 3.99349C2.44798 5.00427 1.93448 6.26735 1.84695 7.59408C1.75946 8.92099 2.10267 10.2412 2.82644 11.3568C3.55017 12.4722 4.61536 13.3237 5.86258 13.7845C7.10995 14.2453 8.47311 14.2904 9.74832 13.9134C11.0234 13.5364 12.1425 12.7576 12.9387 11.6927C13.7348 10.6278 14.1654 9.33378 14.1663 8.00423V7.39095C14.1663 7.11492 14.3903 6.89113 14.6663 6.89095C14.9424 6.89095 15.1663 7.11481 15.1663 7.39095V8.00423C15.1654 9.54962 14.6648 11.0536 13.7395 12.2913C12.8142 13.5289 11.5134 14.4343 10.0315 14.8724C8.54961 15.3105 6.96545 15.2585 5.5159 14.723C4.06633 14.1874 2.82868 13.1971 1.98758 11.9007C1.14649 10.6043 0.747265 9.07065 0.848906 7.52865C0.950583 5.98667 1.54805 4.51884 2.55203 3.34408C3.55608 2.16934 4.91285 1.34974 6.42019 1.00912ZM14.3128 2.31283C14.5079 2.11769 14.8245 2.11787 15.0198 2.31283C15.2151 2.50789 15.2156 2.82447 15.0208 3.01986L8.35379 9.69369C8.26009 9.78742 8.13281 9.84009 8.00027 9.84017C7.86774 9.8402 7.74053 9.78733 7.64676 9.69369L5.64676 7.69369L5.5823 7.61556C5.45394 7.42146 5.47581 7.1576 5.64676 6.98666C5.81751 6.81597 6.08067 6.79433 6.27469 6.9222L6.35379 6.98666L7.9993 8.63216L14.3128 2.31283Z"
        fill="currentColor"
        fillOpacity="0.702"
      />
    </g>
    <defs>
      <clipPath id="clip0_license_verification">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { SvgComponent as LicenseVerificationIcon };

